module.exports = __webpack_public_path__ + "img/ring_y_c_1_null@3x.662ec4c7.png";